// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2bc8R","alertIcon":"ConfirmModal_alertIcon__qN6i9"};